export class SpecialDay {
  constructor(specialDay = {}) {
    this.id = specialDay.id;
    this.name = specialDay.name;
    this.date = specialDay.date;
  }
}
